@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<div class="span9">
  <h1 data-automation-name="metadataReportIndex">Metadata Reports</h1>
</div>
<p class="lead">
  Metadata reports are potential reports that a VEN may send to a VTN. During registration, the VEN sends all
  metadata reports it may produce to the VTN, and the VTN may choose to schedule a reoccurring report from the VEN.
  Each metadata report contains a set of RIDs and their description. When creating a registered report,
  the VTN may choose any of the RIDs in the metadata report to be included in the registered report.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align:right;">
    <a id="createMetadataReport" class="btn btn-large btn-primary" (click)="nextPage($event, '/createMetadataReport', router)" style="margin-top:9px;"> Create Metadata Report</a>
  </div>
}

@if(isLoading) {
  <app-loader
    message="Loading Metadata Reports...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <!-- Column headers -->
    <tr>
      <th>ID</th>
      <th>Data Source</th>
      <th>Report Type</th>
      <th>Report Specifier ID</th>
      <th>Label</th>
      <th>Created At</th>
      <th># RID</th>
      <th># Registered Reports</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="ID" class="input-sm form-control" type="search" [(ngModel)]="idSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Data Source" class="input-sm form-control" type="search" [(ngModel)]="dataSourceSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Report Type" class="input-sm form-control" type="search" [(ngModel)]="reportTypeSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Report Specifier ID" class="input-sm form-control" type="search" [(ngModel)]="reportSpecifierIdSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Label" class="input-sm form-control" type="search" [(ngModel)]="labelSearch" (input)="triggerSearch()"/></th>
      <th><input placeholder="Created At" class="input-sm form-control" type="search" [(ngModel)]="createdAtSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th></th>
      <th></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(metadataReport of displayedMetadataReports | paginate: paginationModel; track metadataReport) {
        <tr>
          <td>{{metadataReport.id}}</td>
          <td>{{metadataReport.data_source}}</td>
          <td>{{metadataReport.report_type}}</td>
          <td>{{metadataReport.report_specifier_id}}</td>
          <td>{{metadataReport.label}}</td>
          <td>{{metadataReport.created_at}}</td>
          <td>{{metadataReport.rids.length || 0}}</td>
          <td>{{metadataReport.registered_reports.length || 0}}</td>
          <td>{{metadataReport.updated_by}}</td>
          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <a
                  class="btn btn-default"
                  (click)="nextPage(metadataReport.id, '/editMetadataReport', router)"
                  name="editMetadataReport"
                >Edit</a>
                <button
                  class="btn btn-danger"
                  type="button"
                  (click)="delete(metadataReport)"
                >
                  Delete
                </button>
              </div>
            </td>
          }
        </tr>
      }
      @if(displayedMetadataReports.length <= 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 10 : 9" style="text-align: center;">No metadata reports found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 10 : 9">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
